<template>
  <div style="width: 100%">
    <el-table
      :fit="true"
      row-key="id"
      highlight-current-row
      style="width: 100%; font-size: 13px"
      @sort-change="handleSort"
      :data="handleSearch"
      :cell-style="{ cursor: 'pointer' }"
      @row-click="rowClickedCollab"
      ref="tableDataCollab"
      clickable-rows
      :header-cell-style="{ color: '#333' }"
      @expand-change="handleExpand"
      :expand-row-keys="expands"
    >
      <el-table-column type="expand">
        <template slot-scope="props">
          <el-table
            style="font-size: 12px; margin-left: 50px; width: 80%"
            :data="props.row.distribution"
            :header-cell-style="{ color: '#333' }"
            @sort-change="
              (column) => handleSortInner(column, props.row.distribution)
            "
          >
            <el-table-column
              sortable="custom"
              label="Código C.C"
              prop="cost_center_cod"
              resizable
              min-width="80"
            >
              <template slot-scope="scope">
                <span class="cursor-pointer">{{
                  scope.row.cost_center_cod
                }}</span>
              </template>
            </el-table-column>
            <el-table-column
              sortable="custom"
              label="Centro de custo"
              prop="cost_center_name"
              min-width="100"
            ></el-table-column>
            <el-table-column
              sortable="custom"
              label="Rateio por projeto"
              prop="value_allocated"
              min-width="100"
            >
              <template slot-scope="scope">
                <span class="cursor-pointer">{{
                  scope.row.value_allocated.toLocaleString(constants.language, {
                    style: "currency",
                    currency: constants.currency,
                  })
                }}</span>
              </template>
            </el-table-column>
            <el-table-column
              sortable="custom"
              label="Alocação"
              prop="percentage_allocated"
              min-width="100"
            >
              <template slot-scope="scope">
                <el-progress
                  :text-inside="false"
                  :stroke-width="10"
                  :percentage="
                    parseFloat(formatterNumber(scope.row.percentage_allocated))
                  "
                  :color="
                    apportionment.status !== constants.status.closed
                      ? '#e87305'
                      : 'rgb(117, 117, 117)'
                  "
                />
              </template>
            </el-table-column>
            <el-table-column
              label="Ações"
              :render-header="renderHeader"
              v-if="apportionment.status !== 'CLOSED'"
            >
              <template slot-scope="scope" style="align-items: center">
                <b-icon
                  class="icon-beaut"
                  style="margin-top: -5px !important; margin-bottom: 3px"
                  icon="pencil"
                  font-scale="1.2"
                  @click="handleCurrentCollaborator(scope.row)"
                ></b-icon>
                <el-popover
                  placement="left"
                  v-model="scope.row.popVisible"
                  :ref="'popover' + scope.$index"
                >
                  <div class="confirm-items">
                    <div>
                      <b-icon
                        style="
                          margin-left: 10px;
                          margin-right: 10px;
                          color: #e87305;
                        "
                        class="icon-beaut"
                        icon="info-circle-fill"
                        font-scale="1"
                      ></b-icon>
                    </div>
                    <div>
                      <span style="word-break: break-word"
                        >Remover colaborador?
                      </span>
                      <p
                        style="
                          word-break: break-word;
                          margin-top: 10px;
                          font-size: 12px;
                        "
                      >
                        Após a remoção não será possível restaura o rateio.
                      </p>
                    </div>
                  </div>

                  <div style="text-align: right; margin: 0; margin-top: 5px">
                    <el-button
                      style="background: #eaeaea; color: #515151"
                      type="text"
                      :disabled="isLoadingBtnRemove"
                      @click="scope.row.popVisible = false"
                      >cancelar</el-button
                    >
                    <el-button
                      :loading="isLoadingBtnRemove"
                      @click="handleDelete(scope.row)"
                      >confirmar</el-button
                    >
                  </div>
                  <b-icon
                    slot="reference"
                    class="icon-beaut"
                    icon="x"
                    font-scale="2"
                  ></b-icon>
                </el-popover>
              </template>
            </el-table-column>
          </el-table>
        </template>
      </el-table-column>
      <el-table-column label="Nome" prop="name" sortable="custom">
        <template slot-scope="scope">
          <span class="cursor-pointer">{{ scope.row.name }}</span>
        </template>
      </el-table-column>
      <el-table-column label="Área" prop="office" sortable="custom">
        <template slot-scope="scope">
          <span class="cursor-pointer">{{ scope.row.area }}</span>
        </template>
      </el-table-column>
      <el-table-column sortable="custom" label="Custo" prop="total_cost" />
      <el-table-column
        sortable="custom"
        label="Disponibilidade"
        prop="availability"
      >
        <template slot-scope="scope">
          <span class="cursor-pointer"
            >{{ formatterNumber(scope.row.availability).toFixed(2) }}%</span
          >
        </template>
      </el-table-column>
      <el-table-column sortable="custom" label="Residual" prop="residual">
        <template slot-scope="scope">
          <span class="cursor-pointer">{{
            formatterNumber(scope.row.residual).toLocaleString(
              constants.language,
              {
                style: "currency",
                currency: constants.currency,
              }
            )
          }}</span>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination">
      <Paginator
        :pageSize="pageSize"
        :total="dataTableTemp.length"
        :start="(page - 1) * pageSize + 1"
        :end="
          page * pageSize > dataTableTemp.length
            ? dataTableTemp.length
            : (page - 1) * pageSize + pageSize
        "
        @set-page-size="setCurrentPageSize"
      />
      <el-pagination
        :hide-on-single-page="true"
        layout="prev, pager, next"
        :total="dataTableTemp.length"
        :page-size="pageSize"
        :current-page="page"
        @current-change="setPage"
      />
    </div>
    <el-drawer
      title="Atualizar distribuição"
      :visible.sync="drawer"
      :direction="direction"
      :before-close="handleClose"
      :wrapperClosable="false"
    >
      <div class="drawer">
        <div class="drawer-text-header">
          <span class="drawer-text-title">Alocação</span>
          <span class="drawer-text">{{ currentCostCenter }}</span>
        </div>
        <div class="drawer-content">
          <div style="display: flex; flex-direction: column">
            <span
              class="drawer-text-title"
              style="font-size: 12px !important; margin-bottom: 15px"
              >Informe o % de alocação</span
            >
            <div class="drawer-inner-content">
              <el-input
                id="inputDrawer"
                style="width: 130px; margin-right: 10px"
                v-model="currentPercentage"
                type="number"
                size="medium"
                placeholder="Percentual"
                :value="currentPercentage"
              >
              </el-input>
              <span style="font-size: 12px">%</span>
            </div>
          </div>
          <div class="drawer-footer">
            <el-button
              style="background: #eaeaea; color: #515151"
              type="text"
              @click="handleDrawerCancel"
              >cancelar</el-button
            >
            <el-button @click="savePercentage" :loading="isLoadingBtnConfirm"
              >Atualizar</el-button
            >
          </div>
        </div>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import api from "../utils/api";
import dayjs from "../utils/dayjs";

import constants from "../utils/constants";
import Paginator from "./Paginator.vue";
import sortDataTable from "../utils/sortDataTable";

export default {
  name: "CollaboratorsTable",
  template: "#CollaboratorsTable",
  components: {
    Paginator,
  },
  props: {
    search: String,
    dataTable: Array,
    apportionment: Object,
    getInformations: Function,
  },
  data() {
    return {
      expands: [],
      lastRow: null,
      cellIsOpened: false,
      currentCollaboratorId: "",
      currentCostCenterId: "",
      currentCostCenter: "",
      constants: constants,
      isLoadingBtnConfirm: false,
      dayjs: dayjs,
      direction: "rtl",
      page: 1,
      pageSize: 10,
      drawer: false,
      dataTableTemp: [],
      currentPercentage: 0,
      referential: 0,
      isLoadingBtnRemove: false,
      searchColumnsCollaborators: [
        "name",
        "availability",
        "office",
        "residual",
        "total_cost",
        "registration",
        "area",
      ],
    };
  },
  computed: {
    ...mapGetters(["getLocationId", "formatterNumber"]),
    pagedTableData() {
      const data = this.dataTableTemp.slice(
        this.pageSize * this.page - this.pageSize,
        this.pageSize * this.page
      );
      if (data.length === 0) {
        this.page = 1;
      }
      return data;
    },
    handleSearch() {
      if (this.search.length > 0) {
        this.dataTableTemp = this.dataTable.filter((item) => {
          for (let value of this.searchColumnsCollaborators) {
            if (
              String(item[value])
                .toLowerCase()
                .includes(this.search.toLowerCase())
            )
              return item;
          }
        });
      } else {
        this.dataTableTemp = this.dataTable;
      }
      return this.pagedTableData;
    },
  },
  async created() {
    this.locationId = this.getLocationId;
    this.dataTableTemp = this.dataTable;
  },
  methods: {
    handleExpand(row) {
      this.referential = row.referential;
      this.currentCollaboratorId = row.id;

      const id = row.id;
      const lastId = this.expands[0];
      this.expands = id === lastId ? [] : [id];
    },
    handleDelete(row) {
      this.isLoadingBtnRemove = true;
      api
        .delete(`/deleteDistribution/${row.id}`)
        .then(({ data }) => {
          let index = 0;
          for (let elem of this.dataTableTemp) {
            if (elem.id === this.currentCollaboratorId) {
              this.deleteElement(index, data, "distribution");
              break;
            }
            index++;
          }
          this.isLoadingBtnRemove = false;
          this.toggleApportionment(data.apportionment);
          this.$message({
            type: "success",
            message: "Rateio atualizado!",
          });
          row.popVisible = false;
        })
        .catch(() => {
          this.isLoadingBtnRemove = false;
          this.$message({
            showClose: true,
            type: "error",
            message: "Não foi possível atualizar o rateio.",
          });
        });
    },
    deleteElement(indexApportionment, newValue, key) {
      let count = 0;
      for (let item of this.dataTableTemp[indexApportionment][key]) {
        if (item.id === newValue.distribution.id) {
          this.dataTableTemp[indexApportionment][key].splice(count, 1);
          break;
        }
        count++;
      }
      this.dataTableTemp[indexApportionment].residual =
        newValue.distribution.collaborator.residual;
    },
    setCurrentPageSize(pageSize) {
      this.setPage(1);
      this.pageSize = pageSize.size;
    },
    setPage(val) {
      this.page = val;
    },
    handleDrawerCancel() {
      this.currentCostCenter = "";
      this.currentCostCenterId = "";
      this.currentPercentage = 0;
      this.drawer = false;
      this.isLoadingBtnConfirm = false;
    },
    handleCurrentCollaborator(row) {
      this.currentCostCenter = row.name;
      this.currentCostCenterId = row.id;
      this.currentPercentage = row.percentage_allocated.toFixed(2);
      this.drawer = true;
      this.isLoadingBtnConfirm = false;
    },
    handleClose() {
      this.currentCostCenter = "";
      this.currentCostCenterId = "";
      this.currentPercentage = 0;
      this.drawer = false;
      this.isLoadingBtnConfirm = false;
    },
    savePercentage() {
      this.isLoadingBtnConfirm = true;

      this.$confirm(
        "Após esta ação não será mais possível restaurar o rateio.",
        `Salvar informações`,
        {
          confirmButtonText: "Confirmar",
          cancelButtonText: "Cancelar",
          customClass: "alert-class",
          confirmButtonClass: "btnFalses",
          cancelButtonClass: "btnCancelFalses",
          type: "warning",
          beforeClose: (action, instance, done) => {
            if (action === "confirm") {
              instance.confirmButtonLoading = true;
              instance.confirmButtonText = "Atualizando...";
              api
                .put(`/updateDistribution/${this.currentCostCenterId}`, {
                  percentage_allocated: parseFloat(this.currentPercentage),
                  referential: parseFloat(this.referential),
                })
                .then(({ data }) => {
                  let index = 0;
                  for (let elem of this.dataTableTemp) {
                    if (elem.id === this.currentCollaboratorId) {
                      this.updateElement(index, data, "distribution");
                      break;
                    }
                    index++;
                  }
                  this.isLoadingBtnConfirm = false;
                  instance.confirmButtonLoading = false;
                  instance.confirmButtonText = "Confirmar";
                  this.drawer = false;
                  this.toggleApportionment(data.apportionment);
                  this.$message({
                    type: "success",
                    message: "Atualizado com sucesso!",
                  });
                  done();
                })
                .catch(() => {
                  this.isLoadingBtnConfirm = false;
                  instance.confirmButtonLoading = false;
                  instance.confirmButtonText = "Confirmar";
                  this.$message({
                    type: "error",
                    message: "Erro ao tentar salvar informações.",
                  });
                });
            } else {
              this.isLoadingBtnConfirm = false;
              instance.confirmButtonLoading = false;
              this.isLoadingBtnConfirm = false;
              instance.confirmButtonText = "Confirmar";
              done();
            }
          },
        }
      )
        .then(() => {})
        .catch(() => {
          this.isLoadingBtnClose = false;
        });
    },
    updateElement(index, newValue, key) {
      let count = 0;
      for (let item of this.dataTableTemp[index][key]) {
        if (item.id === newValue.distribution.id) {
          this.dataTableTemp[index][key][count].value_allocated =
            newValue.distribution.collaborator.value_allocated;
          this.dataTableTemp[index][key][count].percentage_allocated =
            newValue.distribution.collaborator.percentage_allocated;
          break;
        }
        count++;
      }
      this.dataTableTemp[index].residual = this.formatterNumber(
        newValue.distribution.collaborator.residual
      );
    },
    rowClickedCollab(row) {
      this.referential = row.referential;
      this.currentCollaboratorId = row.id;

      if (this.lastRow !== null && this.lastRow.id === row.id) {
        this.lastRow = null;
        this.cellIsOpened = false;
      } else {
        this.cellIsOpened = true;
      }

      this.$refs.tableDataCollab.toggleRowExpansion(this.lastRow);
      this.$refs.tableDataCollab.toggleRowExpansion(row);

      this.lastRow = this.cellIsOpened ? row : null;
    },
    handleSort(column) {
      this.dataTable = sortDataTable(this.dataTable, column);
    },
    handleSortInner(column, table) {
      table = sortDataTable(table, column);
    },
    toggleApportionment(apportionmentData) {
      this.$emit("toggle-apportionment", { ...apportionmentData });
    },
    renderHeader() {
      return (
        <div style="background: #fff; display: flex; align-items: center">
          <div>
            <span>Ações</span>
          </div>
          <div>
            <el-tooltip
              class="item"
              content="Inserir nova distribuição"
              placement="top"
            >
              <b-icon
                style="margin-left: 3px"
                onClick={() =>
                  this.$emit("toggle-drawer", {
                    collaborator_id: this.currentCollaboratorId,
                    typeInsert: "project",
                  })
                }
                class="icon-beaut"
                icon="plus"
                font-scale="2"
              ></b-icon>
            </el-tooltip>
          </div>
        </div>
      );
    },
  },
};
</script>
